/**
 * 角色原始定义
 */
export enum Role {
    // 超级管理员
    Admin = 'Admin',
    // 平台管理员
    CmpAdmin = 'CmpAdmin', //企业管理员 可以多个
    CmpInspector = 'CmpInspector', //企业监督员 可以多个
    // 项目管理员
    ProjManager = 'ProjManager', // 项目管理员 可以多个
    ProjTechManager = 'ProjTechManager', // 技术负责人  可以多个
    ProjSiteManager = 'ProjSiteManager', //现场负责人 可以多个
    ProjChecker = 'ProjChecker', // 检测人员 可以多个
    ProjInspector = 'ProjInspector', // 监督员 可以多个
}
/**
 * 对应中文名称
 */
export enum RoleName {
    Admin = '超级管理员',
    CmpAdmin = '平台管理者',
    CmpInspector = '平台督察者',
    ProjManager = '项目负责人',
    ProjTechManager = '项目技术负责人',
    ProjSiteManager = '现场负责人',
    ProjChecker = '检测人员',
    ProjInspector = '督察人员',
}

/**
 * 获取 当前用户的低一级的角色列表
 * @param role 
 */
export const accessRoles = (role?: string): { value: string; name: string }[] => {
    // 有序
    const roles = Object.keys(Role);
    const index = roles.findIndex(rk => rk === role);
    return roles.slice(index).map((rk) => {
        return {
            value: rk,
            name: RoleName[rk]
        }
    });
}